export enum PlanningView {
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Year = "Year",
}
